// js
import React from 'react';
import PropTypes from 'prop-types';


const SecurityDetailCorrelationListCategory = ({
  category,
  limit = 99999,
  showAdditionalCount = false
}) => {

  const visibleCorrelations = category.correlations.slice(0, limit);
  const additionalCorrelationCount = Math.max(category.correlations.length - limit, 0);
  const title = category.title === 'Additional Items' ? category.title : `${category.title} Correlations`;
  const itemsMarkup = (
    <ul>
      {visibleCorrelations.map(correlation => (
        <li
          key={correlation.title}
          className='analytics__security-detail-correlation-list__correlation-item'
        >
          <span>{correlation.title}</span>
        </li>
      ))}
    </ul>
  );

  return (
    <div className='analytics__security-detail-correlation-list__category'>
      <h4>
        <span className='analytics__security-detail-correlation-list__category-correlations-count'>{category.correlations.length}</span>
        <span className='analytics__security-detail-correlation-list__category-title'>{title}</span>
      </h4>
      {itemsMarkup}
      {showAdditionalCount &&
        <p className='analytics__security-detail-correlation-list__category__additional-correlation-count'>{additionalCorrelationCount} additional {title} found</p>
      }
    </div>
  );
};

SecurityDetailCorrelationListCategory.propTypes = {
  category: PropTypes.object.isRequired,
  limit: PropTypes.number,
  showAdditionalCount: PropTypes.bool
};

export default SecurityDetailCorrelationListCategory;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityDetailCorrelationListCategory.js